import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

let sesssionUserinfo = JSON.parse(window.sessionStorage.getItem('userinfo'));
console.log(sesssionUserinfo)
const state = {
    token: window.sessionStorage.getItem('token'),
    menus: sesssionUserinfo?sesssionUserinfo.menus:'',
    permissions: sesssionUserinfo?sesssionUserinfo.permissions:[],
    username: sesssionUserinfo?sesssionUserinfo.username:'',
    refreshToken: sesssionUserinfo?sesssionUserinfo.refreshToken:'',
    expireTime: sesssionUserinfo?sesssionUserinfo.expireTime:'',
    userLevel:sesssionUserinfo?sesssionUserinfo.userLevel:'',
    salesOffices:sesssionUserinfo?sesssionUserinfo.salesOffices:'',
    regions:sesssionUserinfo?sesssionUserinfo.regions:''
};
console.log(state)
const mutations = {
    LOGIN: (state, data) => {
        state.token = data;
        window.sessionStorage.setItem('token', data);
    },
    LOGOUT: (state) => {
        state.token = null;
        window.sessionStorage.removeItem('token');
        window.sessionStorage.removeItem('userinfo');
    },
    USERINFO: (state, data) => {
        let userinfo = JSON.parse(data);
        state.menus = userinfo?userinfo.menus:'';
        state.permissions = userinfo?userinfo.permissions:[];
        state.username = userinfo?userinfo.username:'';
        state.refreshToken = userinfo?userinfo.refreshToken:'';
        state.expireTime = userinfo?userinfo.expireTime:'';
        state.userLevel = userinfo?userinfo.userLevel:'';
        state.salesOffices = userinfo?userinfo.salesOffices:'';
        state.regions = userinfo?userinfo.regions:'';
        window.sessionStorage.setItem('userinfo', data);
    }
};
const actions = {
    UserLogin({ commit }, data){
        commit('LOGIN', data);
    },
    UserLogout({ commit }){
        commit('LOGOUT');
    },
    UserInfo({ commit }, data){
        commit('USERINFO', data);
     }
};
export default new Vuex.Store({
    state,
    mutations,
    actions
});


// WEBPACK FOOTER //
// ./src/store/index.js